import React from "react";
import { TextField, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { styles } from "./UserInputForm.styles";
import { FONT_SIZES } from "../../constants/fontSizes";

const InputWithTooltip = ({ name, tooltipText, ...props }) => (
  <Tooltip
    title={tooltipText}
    arrow
    placement="right"
    enterDelay={200}
    leaveDelay={0}
    id={name}
    name={name}
    componentsProps={{
      tooltip: {
        sx: {
          fontSize: FONT_SIZES.TEXT_HINT.xs,
          "@media (min-width: 600px)": {
            fontSize: FONT_SIZES.TEXT_HINT.sm,
          },
        },
      },
    }}
  >
    <TextField
      {...props}
      name={name}
      id={name}
      variant="standard"
      sx={styles.textField}
      InputProps={{
        endAdornment: <InfoIcon color="action" sx={styles.infoIcon} />,
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  </Tooltip>
);

export default InputWithTooltip;
